import type { PiiJsonValue } from '@onefootprint/request-types/dashboard';
import { create } from 'zustand';

// One-time scrub: this key may still hold decrypted PII in localStorage from before this store went memory-only.
if (typeof window !== 'undefined') {
  window.localStorage.removeItem('document-viewer-decrypted-vault-data');
}

type DecryptedData = Record<string, PiiJsonValue>;

type DecryptedVaultDataStore = {
  // Store decrypted data per document identifier
  decryptedDataByDocument: Record<string, DecryptedData>;
  addDecryptedData: (documentIdentifier: string, data: DecryptedData) => void;
  reset: (documentIdentifier?: string) => void;
};

export const useDecryptedVaultDataStore = create<DecryptedVaultDataStore>()(set => ({
  decryptedDataByDocument: {},
  addDecryptedData: (documentIdentifier: string, data: DecryptedData) =>
    set(state => ({
      decryptedDataByDocument: {
        ...state.decryptedDataByDocument,
        [documentIdentifier]: {
          ...(state.decryptedDataByDocument[documentIdentifier] || {}),
          ...data,
        },
      },
    })),
  reset: (documentIdentifier?: string) => {
    if (documentIdentifier) {
      // Reset specific document
      set(state => {
        const { [documentIdentifier]: _, ...rest } = state.decryptedDataByDocument;
        return { decryptedDataByDocument: rest };
      });
    } else {
      // Reset all
      set({ decryptedDataByDocument: {} });
    }
  },
}));
